import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import './parsers/index.js';
import { TextWrapper } from './Components.js';
import { defaultMarkdownParser } from './parsers/defaultMarkdownParser.js';

/**
 * Markdown.
 *
 * Transform normal text to markdown text.
 *
 * @param {Object} props - Component Props.
 * @param [{string}] props.className - Style class for the markdown text wrapper.
 * @param {string} props.children - String with the text marked.
 * @param {string} props.parser - Parser to be used.
 *
 * @returns {React.ReactElement} - React element.
 *
 * @example // Basic example
 * <Markdown>"Hello I am `Normal Text` but I will markdown :smile:"</Markdown>
 */
const MarkdownBase = ({ className, children, 'data-testid': dataTestId, parser, }) => {
    const markdown = useMemo(() => {
        return parser(children);
    }, [children, parser]);
    return (jsx(TextWrapper, Object.assign({ className: className, "data-testid": dataTestId }, { children: markdown })));
};
MarkdownBase.defaultProps = {
    children: '',
    parser: defaultMarkdownParser,
};
MarkdownBase.propTypes = {
    className: PropTypes.string,
    children: PropTypes.string,
    parser: PropTypes.func,
    'data-testid': PropTypes.string,
};
const Markdown = styled(MarkdownBase) `
  /* Prevents text for causing overflow */
  overflow-wrap: break-word;
  hyphens: auto;

  /* Prevents links for causing overflow */
  & a {
    white-space: normal;
    word-break: break-all;
  }
`;

export { Markdown, MarkdownBase };
